import axios from 'axios';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({
  // baseURL:'http://192.168.1.13:8000/'
  baseURL: 'https://mgnlotto.net/'
  // baseURL: 'http://127.0.0.1:8000'
});

// Intercepteur pour gérer les réponses
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Vérifier si c'est une erreur 401 (Non autorisé)
    if (error.response && error.response.status === 401) {
      console.log('Token invalide ou expiré - Déconnexion...');
      
      // Supprimer le token du localStorage
      localStorage.removeItem('accessToken');
      localStorage.removeItem('role');
      
      // Supprimer l'en-tête Authorization
      delete axiosInstance.defaults.headers.common.Authorization;
      
      // Rediriger vers la page de login
      // Utilisez window.location.href pour une redirection simple
      window.location.href = '/login';
      
      // Ou si vous utilisez React Router, vous pouvez faire :
      // window.location.reload(); // Force le rechargement et la redirection via les routes
    }
    
    // Retourner l'erreur pour qu'elle soit traitée par le code appelant
    return Promise.reject((error.response && error.response.data) || 'Something went wrong');
  }
);

export default axiosInstance;